import { Intent, Switch, SwitchProps } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import styles from "./styles.module.css"
export type ToggleProps = SwitchProps & {
  intent?: Intent
}
const Toggle = ({ className, intent, ...props }: ToggleProps) => {
  return (
    <Switch
      className={classNames(styles["base"], styles[intent], className)}
      {...props}
    />
  )
}

export default Toggle
